module.exports = __webpack_public_path__ + "media/images/ajax-loader-60b8b112d26390fbea0346650025a9f1.gif";